export enum DeviceType {
  None = "none",
  InfusionSet = "infusion_set",
  InsulinPen = "insulin_pen",
  Sensor = "sensor",
  Transmitter = "transmitter",
  PumpCartridge = "pump_cartridge",
  NotProvided = "not_provided",
}
